module.exports = __webpack_public_path__ + "assets/terms/termos-do.e448ee74.pdf";